"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CTGGameModeDodge = void 0;
const CTGCard_1 = require("../Logic/CTGCard");
const CTGGameModeNormal_1 = require("./CTGGameModeNormal");
const CTG_1 = require("../CTG");
class CTGGameModeDodge extends CTGGameModeNormal_1.CTGGameModeNormal {
    constructor(generator, starting_rows, speed, animators = null) {
        super(true, generator, starting_rows, speed, animators);
    }
    reset() {
        super.reset();
        this.controlled_card = null;
        this.slots = [];
        this.current_x = 0;
        for (let i = 0; i < 4; i++) {
            this.slots.push(this.fixed_x_position(i));
        }
    }
    generate_initial_cards(rand, difficulty) {
        let specs = super.generate_initial_cards(rand, difficulty);
        this.controlled_card = new CTGCard_1.CTGCard(CTGCard_1.CTGSuit.Diamonds, CTGCard_1.CTGRank.Ace);
        this.controlled_card.x = this.fixed_x_position(1.5);
        this.controlled_card.y = this.fixed_y_position(0);
        specs.push(this.controlled_card);
        return specs;
    }
    card_tapped(card) {
        // This is left blank to prevent the normal game mode behavior.
    }
    update_game(scene, now, delta, difficulty, mx, my, mdown) {
        super.update_game(scene, now, delta, difficulty, mx, my, mdown);
        // Used if we wanted to peg the position, which didn't feel great.
        // let closest_slot = this.closest_slot(mx);
        let nx = Math.max(this.slots[0], Math.min(this.slots[this.slots.length - 1], mx));
        let collided_cards = this.check_for_collisions_at_slots(mx, this.controlled_card.y, 0, this.slots.length - 1);
        this.current_x = nx;
        this.controlled_card.move(this.current_x, this.controlled_card.y);
        collided_cards.forEach(element => {
            if (element.tap_requirement == CTGCard_1.CTGTapRequirement.Dont) {
                this.lose([element]);
            }
            else {
                element.destroy(true, true);
            }
        });
    }
    closest_slot(x) {
        let closest_slot = 0;
        let closest_dist = Math.abs(this.slots[0] - x);
        for (let i = 1; i < this.slots.length; i++) {
            let new_dist = Math.abs(this.slots[i] - x);
            if (new_dist < closest_dist) {
                closest_dist = new_dist;
                closest_slot = i;
            }
        }
        return closest_slot;
    }
    check_for_collisions_at_slots(cx, cy, from, to) {
        let rows = [];
        // Make sure from is always less than to for the for loop.
        if (from > to) {
            const swap = to;
            to = from;
            from = swap;
        }
        from = Math.floor(from);
        to = Math.ceil(to);
        for (let i = from; i <= to; i++) {
            rows.push(...this.check_for_collisions_at_slot(cx, cy, i));
        }
        return rows;
    }
    check_for_collisions_at_slot(cx, cy, slot) {
        const rows_to_check = 2;
        const collisions = [];
        if (slot < 0)
            return collisions;
        if (this.rows.length < rows_to_check)
            return collisions;
        for (let i = 0; i < rows_to_check; i++) {
            if (this.rows[i].length <= slot)
                continue;
            if (this.rows[i][slot] == null)
                continue;
            let other_card = this.rows[i][slot];
            let overlap_allowance = other_card.tap_requirement == CTGCard_1.CTGTapRequirement.Dont ? 2 : 0;
            // Only compare Y as we know X will be the same.
            if (Math.abs(cy - other_card.y) < CTG_1.card_size[1] - overlap_allowance
                && Math.abs(cx - other_card.x) < CTG_1.card_size[0] - overlap_allowance) {
                collisions.push(other_card);
            }
        }
        return collisions;
    }
}
exports.CTGGameModeDodge = CTGGameModeDodge;
